﻿var urlApi;

var ajusteFuso = 0;

$(document).ready(function () {

  urlApi = window.location.protocol + "//" + document.domain + "/enet";

  /*ajusteFuso = 0;

  var data = new Date();

  data.setHours(data.getHours() - 17);

  //alert(data.getHours() + ":" + data.getMinutes() + ":" + data.getSeconds());
  alert(data);*/
});

